import type { CSSProperties } from 'react';
import { Typography } from '@src/components/Typography/Typography';
import './TokenRow.css';

export type TokenPreview = 'color' | 'length' | 'radius' | 'shadow' | 'value';

export interface TokenRowProps {
  name: string;
  value: string;
  preview: TokenPreview;
}

const COLOUR_VALUE = /^(#|rgb|hsl|oklch|color-mix|light-dark|transparent$|currentcolor$)/i;

function isColourValue(value: string): boolean {
  return COLOUR_VALUE.test(value);
}

export function TokenRow({ name, value, preview }: TokenRowProps) {
  const specimen = { '--specimen-value': value } as CSSProperties;
  const effective: TokenPreview = preview === 'color' && !isColourValue(value) ? 'value' : preview;

  return (
    <li className="token-row">
      {effective === 'value' ? (
        <span className="token-row__preview token-row__preview--empty" />
      ) : (
        <span className={`token-row__preview token-row__preview--${effective}`} style={specimen} />
      )}
      <Typography as="code" role="meta/mono" className="token-row__name">
        {name}
      </Typography>
      <Typography as="code" role="meta/mono" className="token-row__value">
        {value}
      </Typography>
    </li>
  );
}
